export const PROJECT_NAME_MAX_LENGTH = 60;

export interface Project {
  id: string;
  name: string;
  organizationId: string;
  createdByUserId: string;
  dateCreated: string;
  dateUpdated: string;
  coursesNumber: number;
  microreelsNumber: number;
  postsNumber: number;
}

export interface ProjectFilter {
  projectId?: string;
  unassignedOnly?: boolean;
}
